import { jsx as _ } from "react/jsx-runtime";
function f(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var l = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var d;
function g() {
  return d || (d = 1, function(t) {
    (function() {
      var s = {}.hasOwnProperty;
      function n() {
        for (var e = "", r = 0; r < arguments.length; r++) {
          var i = arguments[r];
          i && (e = p(e, h(i)));
        }
        return e;
      }
      function h(e) {
        if (typeof e == "string" || typeof e == "number")
          return e;
        if (typeof e != "object")
          return "";
        if (Array.isArray(e))
          return n.apply(null, e);
        if (e.toString !== Object.prototype.toString && !e.toString.toString().includes("[native code]"))
          return e.toString();
        var r = "";
        for (var i in e)
          s.call(e, i) && e[i] && (r = p(r, i));
        return r;
      }
      function p(e, r) {
        return r ? e ? e + " " + r : e + r : e;
      }
      t.exports ? (n.default = n, t.exports = n) : window.classNames = n;
    })();
  }(l)), l.exports;
}
var c = g();
const y = /* @__PURE__ */ f(c), u = {
  "purpur-heading": "_purpur-heading_k9fhq_1",
  "purpur-heading--hyphens": "_purpur-heading--hyphens_k9fhq_8",
  "purpur-heading--negative": "_purpur-heading--negative_k9fhq_11",
  "purpur-heading--subsection-100": "_purpur-heading--subsection-100_k9fhq_14",
  "purpur-heading--title-100": "_purpur-heading--title-100_k9fhq_20",
  "purpur-heading--title-200": "_purpur-heading--title-200_k9fhq_26",
  "purpur-heading--title-300": "_purpur-heading--title-300_k9fhq_32",
  "purpur-heading--title-400": "_purpur-heading--title-400_k9fhq_38",
  "purpur-heading--title-500": "_purpur-heading--title-500_k9fhq_44",
  "purpur-heading--title-600": "_purpur-heading--title-600_k9fhq_50",
  "purpur-heading--title-700": "_purpur-heading--title-700_k9fhq_56",
  "purpur-heading--display-25": "_purpur-heading--display-25_k9fhq_62",
  "purpur-heading--display-50": "_purpur-heading--display-50_k9fhq_68",
  "purpur-heading--display-100": "_purpur-heading--display-100_k9fhq_74",
  "purpur-heading--display-200": "_purpur-heading--display-200_k9fhq_80"
}, k = {
  H1: "h1",
  H2: "h2",
  H3: "h3",
  H4: "h4",
  H5: "h5",
  H6: "h6"
}, T = {
  TITLE100: "title-100",
  TITLE200: "title-200",
  TITLE300: "title-300",
  TITLE400: "title-400",
  TITLE500: "title-500",
  TITLE600: "title-600",
  TITLE700: "title-700",
  SUBSECTION100: "subsection-100"
}, I = {
  DISPLAY25: "display-25",
  DISPLAY50: "display-50",
  DISPLAY100: "display-100",
  DISPLAY200: "display-200"
}, a = "purpur-heading", q = ({
  children: t,
  className: s = "",
  enableHyphenation: n = !1,
  negative: h = !1,
  tag: p,
  variant: e = T.TITLE100,
  ...r
}) => {
  const i = p, o = y([
    s,
    u[a],
    u[`${a}--${e}`],
    {
      [u[`${a}--hyphens`]]: n,
      [u[`${a}--negative`]]: h
    }
  ]);
  return /* @__PURE__ */ _(i, { className: o, ...r, children: t });
};
q.displayName = "Heading";
export {
  I as DisplayVariant,
  q as Heading,
  k as HeadingTag,
  T as TitleVariant
};
//# sourceMappingURL=heading.es.js.map
